import {CustomButtonProps} from '../../types/global.types';
import './styles.scss';
import {observer} from 'mobx-react-lite';
import cn from 'classnames';

const Button: React.FC<Partial<CustomButtonProps>> = observer(
    ({
         className = '',
         size,
         color,
         type,
         children,
         onClick,
         onMouseDown,
         disabled = false,
         styles,
         htmlType,
         ...props
     }) => (
        <button
            {...props}
            disabled={disabled}
            type={htmlType}
            style={styles}
            className={cn(size, color, type, className, {
                button: true,
                disabled,
            })}
            onClick={onClick}
            onMouseDown={onMouseDown}
        >
            {children}
        </button>
    ),
);

export default Button;
